<!-- Template for expand arrow cell - OUTSIDE datatable -->
<ng-template
  #expandCell
  let-row="row"
  let-expanded="expanded">
  <div class="d-flex flex-column align-items-center">
    @if (row.flag) {
      <i
        class="iconoir-dash-flag text-danger"
        title="Transaction has been flagged"></i>
    }
    @if (!canExpandRow || canExpandRow(row)) {
      <button
        class="btn-action"
        type="button"
        title="Expand/Collapse Row"
        (click)="toggleExpandRow(row); $event.stopPropagation()">
        <i
          class="iconoir-nav-arrow-down size-1 text-secondary-2"
          [class.rotate-90]="expanded"></i>
      </button>
    }
  </div>
</ng-template>

<ngx-datatable
  #table
  class="bootstrap {{ class }}"
  [ngClass]="{
    'is-loading-spacer': isLoading && !!data && !dataLength,
    'is-loading-spacer-sm': pageSize === 4,
    'is-loading-spacer-md': pageSize === 8,
  }"
  [rows]="data"
  [limit]="pageSize"
  [count]="dataLength"
  [offset]="getPageOffset()"
  (page)="onChange($event)"
  [columnMode]="'flex'"
  [ghostLoadingIndicator]="isLoading"
  [swapColumns]="false"
  [reorderable]="false"
  [columns]="columns"
  [rowHeight]="56"
  [footerHeight]="0"
  [headerHeight]="56"
  [scrollbarH]="true"
  [externalPaging]="true"
  [externalSorting]="true"
  (sortsChange)="onSort($event)"
  [rowIdentity]="getRowIdentity"
  [messages]="{ emptyMessage: emptyMessage }">
  <!-- Row Detail Template -->
  <ngx-datatable-row-detail
    #rowDetailRef
    [rowHeight]="rowDetailHeight">
    <ng-template
      let-row="row"
      ngx-datatable-row-detail-template>
      @if (rowDetailTemplate) {
        <ng-container *ngTemplateOutlet="rowDetailTemplate; context: { row: row }"></ng-container>
      }
    </ng-template>
  </ngx-datatable-row-detail>
  <ng-content></ng-content>
</ngx-datatable>

<div class="table-footer mt-3">
  <div class="row align-items-center justify-content-center justify-content-sm-between">
    <div class="col-auto">
      <div class="page-count text-center text-sm-start">
        Showing <span class="text-black">{{ rowNumber }}</span> to <span class="text-black">{{ totalShown }}</span> of
        <span class="text-black">{{ dataLength }}</span>
      </div>
    </div>
    <div class="col-auto">
      <!-- Custom Bootstrap Pagination -->
      <pagination
        #paginator
        [totalItems]="dataLength"
        [itemsPerPage]="pageSize"
        (pageChanged)="onPageChange($event)"
        [(ngModel)]="currentPage"
        [maxSize]="5"
        [boundaryLinks]="true"
        [rotate]="false"
        [class.d-none]="!showPagination"
        previousText="&lsaquo;"
        nextText="&rsaquo;"
        firstText="&laquo;"
        lastText="&raquo;">
      </pagination>
    </div>
  </div>
</div>
